(function () {
  "use strict";

  // Configuration constants
  const CONFIG = {
    MAX_WAIT: 3000,
    DEBUG: false,
    SELECTORS: {
      container: ".homepage-carrousel",
      track: ".carrousel-track",
      item: ".carrousel-item",
      placeholder: ".carrousel-external-image-placeholder[data-src]",
    },
    CLASSES: {
      scroller: "carrousel-scroller",
      sequence: "carrousel-sequence",
      ready: "carrousel-ready",
    },
  };

  function log(...args) {
    if (CONFIG.DEBUG) console.log("Carousel:", ...args);
  }

  function replacePlaceholders() {
    log("Replacing placeholders");
    const placeholders = Array.from(
      document.querySelectorAll(CONFIG.SELECTORS.placeholder)
    );

    placeholders.forEach((placeholder) => {
      try {
        const img = createImageFromPlaceholder(placeholder);
        if (placeholder.parentNode) {
          placeholder.parentNode.replaceChild(img, placeholder);
        }
      } catch (e) {
        console.error("Image placeholder replacement error:", e);
      }
    });

    const track = document.querySelector(CONFIG.SELECTORS.track);
    return track ? Array.from(track.querySelectorAll("img")) : [];
  }

  function createImageFromPlaceholder(placeholder) {
    const img = document.createElement("img");
    img.src = placeholder.dataset.src;
    img.alt = placeholder.dataset.alt || "Logo";

    if (placeholder.dataset.height)
      img.setAttribute("height", placeholder.dataset.height);
    if (placeholder.dataset.width)
      img.setAttribute("width", placeholder.dataset.width);

    // Apply consistent styling
    Object.assign(img.style, {
      display: "inline-block",
      height: "auto",
      maxHeight: (placeholder.dataset.height || "") + "px",
      webkitUserDrag: "none",
      userSelect: "none",
      margin: "0",
      padding: "0",
    });

    img.decoding = "async";
    img.loading = "eager";
    img.onerror = function () {
      this.style.display = "none";
    };

    return img;
  }

  function waitForImages(images, timeout) {
    log(`Waiting for ${images.length} images to load`);
    return new Promise((resolve) => {
      let remaining = images.length;
      if (remaining === 0) return resolve();

      let resolved = false;
      const check = () => {
        if (resolved) return;
        if (remaining <= 0) {
          resolved = true;
          log("All images loaded");
          resolve();
        }
      };

      images.forEach((img) => {
        if (img.complete) {
          remaining -= 1;
          check();
          return;
        }

        img.addEventListener("load", () => {
          remaining -= 1;
          check();
        });

        img.addEventListener("error", () => {
          remaining -= 1;
          check();
        });
      });

      setTimeout(() => {
        if (!resolved) {
          log("Image loading timed out");
          resolved = true;
          resolve();
        }
      }, timeout);
    });
  }

  function start() {
    log("Starting carousel setup");
    try {
      const imgs = replacePlaceholders();
      waitForImages(imgs, CONFIG.MAX_WAIT).then(() => {
        const container = document.querySelector(CONFIG.SELECTORS.container);
        if (!container) {
          console.error("Carousel container not found");
          return;
        }

        const track = container.querySelector(CONFIG.SELECTORS.track);
        if (!track) {
          console.error("Carousel track not found");
          return;
        }

        const visibleItems = track.querySelectorAll(CONFIG.SELECTORS.item);
        if (!visibleItems.length) {
          console.error("No carousel items found");
          return;
        }

        try {
          // Create scroller wrapper
          const scroller = document.createElement("div");
          scroller.className = CONFIG.CLASSES.scroller;

          // Create main sequence container
          const sequence = document.createElement("div");
          sequence.className = CONFIG.CLASSES.sequence;

          // Move all items to the sequence with proper spacing normalization
          while (track.firstChild) {
            if (
              track.firstChild.classList &&
              track.firstChild.classList.contains("carrousel-item")
            ) {
              // Normalize all spacing properties to ensure consistent gaps
              const item = track.firstChild;
              Object.assign(item.style, {
                margin: "0",
                padding: "0",
              });

              // Also normalize any images within the item
              const itemImages = item.querySelectorAll("img");
              itemImages.forEach((img) => {
                Object.assign(img.style, {
                  margin: "0",
                  padding: "0",
                });
              });
            }
            sequence.appendChild(track.firstChild);
          }

          scroller.appendChild(sequence);
          track.appendChild(scroller);

          // Force layout calculation
          track.offsetHeight;

          const containerWidth = container.offsetWidth || 1200;
          const seqWidth = sequence.scrollWidth || 0;

          log(
            `Container width: ${containerWidth}px, Sequence width: ${seqWidth}px`
          );

          if (seqWidth === 0) {
            console.error("Failed to calculate sequence width");
            return;
          }

          const duplicatesNeeded =
            Math.ceil((containerWidth * 2) / seqWidth) + 1;
          log(`Creating ${duplicatesNeeded} duplicates`);

          for (let i = 0; i < duplicatesNeeded; i++) {
            const clone = sequence.cloneNode(true);
            scroller.appendChild(clone);
          }

          container.style.setProperty("--carrousel-distance", seqWidth + "px");
          log(`Animation distance set to ${seqWidth}px`);
        } catch (err) {
          console.error("Carousel duplication error:", err);
        }

        requestAnimationFrame(() => {
          container.classList.add(CONFIG.CLASSES.ready);
          log("Carousel ready class added");
        });
      });
    } catch (err) {
      console.error("Carousel initialization error:", err);
      const container = document.querySelector(CONFIG.SELECTORS.container);
      if (container) container.classList.add(CONFIG.CLASSES.ready);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
